/* Black Friday 2026 — early access sign-up (landing form, sticky bar, site pop-up).
   Subscribes to the Klaviyo list with the Client Subscriptions API (SMS first, email second),
   keeps one profile per person (Klaviyo matches on phone, then on email + phone), tracks Lead events.
   The email step is always asked after the phone step: the browser cookie may belong to someone else. */
(function () {
  'use strict';
  var CFG = window.BF_EA || {};
  var SIGNED_KEY = 'bf26_signed_up';
  var CLOSED_KEY = 'bf26_popup_closed_at';
  var SESSION_KEY = 'bf26_popup_seen';
  var STICKY_KEY = 'bf26_sticky_dismissed';
  var HIDE_DAYS = 3;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function signedUp() { return lsGet(SIGNED_KEY) === '1'; }

  function digitsOf(v) { return String(v || '').replace(/\D/g, ''); }
  function toE164(v) {
    var d = digitsOf(v);
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return d.length === 10 && /^[2-9]/.test(d) ? '+1' + d : null;
  }
  function formatUS(v) {
    var d = digitsOf(v);
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    d = d.slice(0, 10);
    if (d.length < 4) return d;
    if (d.length < 7) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); }

  function kl() { return window.klaviyo && typeof window.klaviyo.identify === 'function' ? window.klaviyo : null; }
  function withTimeout(p, ms) { return Promise.race([p, new Promise(function (r) { setTimeout(r, ms); })]); }
  function identify(props) {
    var k = kl();
    if (!k) return Promise.resolve();
    return withTimeout(Promise.resolve(k.identify(props)).catch(function () {}), 2500);
  }

  function subscribe(opts) {
    var attrs = { subscriptions: {} };
    if (opts.phone) { attrs.phone_number = opts.phone; attrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
    if (opts.email) { attrs.email = opts.email; attrs.subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } }; }
    var body = {
      data: {
        type: 'subscription',
        attributes: { custom_source: 'BF26 Early Access - ' + opts.source, profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: CFG.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(CFG.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: CFG.revision || '2025-07-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error('Klaviyo ' + res.status + ' ' + t); });
    });
  }

  // Link this browser to the person who just signed up. Only called with an email (never a phone alone),
  // so a number typed on a shared or already-identified browser can never land on another person's profile.
  function linkVisitor(identifiers) { return kl() && identifiers.email ? identify(identifiers) : Promise.resolve(); }

  // Custom properties (bf_signup_source…), always through the client profiles API: reliable even when the onsite script is blocked.
  function saveProps(identifiers, props) {
    var attrs = Object.assign({}, identifiers, { properties: props });
    return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(CFG.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: CFG.revision || '2025-07-15' },
      body: JSON.stringify({ data: { type: 'profile', attributes: attrs } })
    }).then(function (res) { if (!res.ok && window.console) res.text().then(function (t) { console.warn('[BF26] profile', res.status, t); }); }).catch(function () {});
  }

  function track(step, source) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'bf26_signup', bf_step: step, bf_source: source }); } catch (e) {}
    if (step === 'phone') { try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'BF26 Early Access', content_category: source }); } catch (e) {} }
  }

  function show(form, step) {
    var steps = form.querySelectorAll('[data-step]');
    for (var i = 0; i < steps.length; i++) steps[i].hidden = steps[i].getAttribute('data-step') !== step;
    var target = form.querySelector('[data-step="' + step + '"] input');
    if (target && form.getAttribute('data-autofocus') !== 'false') { try { target.focus({ preventScroll: true }); } catch (e) {} }
    if (step === 'done') document.dispatchEvent(new CustomEvent('bf:done', { detail: { form: form } }));
    document.dispatchEvent(new CustomEvent('bf:step', { detail: { form: form, step: step } }));
  }

  function markSignedUp(form) {
    lsSet(SIGNED_KEY, '1');
    document.dispatchEvent(new CustomEvent('bf:signedup', { detail: { form: form } }));
  }

  function setBusy(btn, busy) { if (btn) { btn.disabled = busy; btn.setAttribute('aria-busy', busy ? 'true' : 'false'); } }

  function initForm(form) {
    if (form.__bf) return; form.__bf = true;
    var source = form.getAttribute('data-source') || 'landing';
    var phoneStep = form.querySelector('[data-step="phone"]');
    var emailStep = form.querySelector('[data-step="email"]');
    var phoneInput = phoneStep && phoneStep.querySelector('input[name="phone"]');
    var phoneE164 = null;

    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var pos = phoneInput.value.length;
        phoneInput.value = formatUS(phoneInput.value);
        if (document.activeElement === phoneInput && pos === phoneInput.value.length) { try { phoneInput.setSelectionRange(pos, pos); } catch (e) {} }
      });
    }

    if (phoneStep) phoneStep.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var err = phoneStep.querySelector('.bf-form__error');
      var btn = phoneStep.querySelector('button[type="submit"]');
      var phone = toE164(phoneInput.value);
      if (!phone) { err.textContent = 'Please enter a valid US or Canadian mobile number.'; phoneInput.focus(); return; }
      err.textContent = '';
      setBusy(btn, true);
      var now = new Date().toISOString();
      // Klaviyo matches the number to an existing profile server-side (no duplicate), whatever cookie the browser holds.
      subscribe({ phone: phone, source: source }).then(function () {
        phoneE164 = phone;
        saveProps({ phone_number: phone }, { bf_signup_source: source, bf_signup_at: now });
        track('phone', source);
        markSignedUp(form);
        if (!emailStep) { show(form, 'done'); track('done', source); }
        else show(form, 'email');
      }).catch(function (e) {
        err.textContent = 'Something went wrong. Please try again in a moment.';
        if (window.console) console.warn('[BF26]', e);
      }).then(function () { setBusy(btn, false); });
    });

    if (emailStep) {
      emailStep.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var input = emailStep.querySelector('input[name="email"]');
        var err = emailStep.querySelector('.bf-form__error');
        var btn = emailStep.querySelector('button[type="submit"]');
        var email = String(input.value || '').trim().toLowerCase();
        if (!validEmail(email)) { err.textContent = 'Please enter a valid email address.'; input.focus(); return; }
        err.textContent = '';
        setBusy(btn, true);
        // Email + phone together: an existing email profile gets the number added (one profile per person).
        subscribe({ email: email, phone: phoneE164, source: source }).then(function () {
          linkVisitor(phoneE164 ? { email: email, phone_number: phoneE164 } : { email: email });
          saveProps({ email: email }, { bf_signup_email_at: new Date().toISOString(), bf_signup_source: source });
          track('email', source);
          show(form, 'done');
        }).catch(function (e) {
          err.textContent = 'Something went wrong. Please try again in a moment.';
          if (window.console) console.warn('[BF26]', e);
        }).then(function () { setBusy(btn, false); });
      });
      var skip = emailStep.querySelector('[data-bf-skip]');
      if (skip) skip.addEventListener('click', function () { show(form, 'done'); track('skip_email', source); });
    }
  }

  // Sticky bar: visible once the main form has left the screen, hidden after sign-up or dismissal.
  function initSticky() {
    var bar = document.querySelector('[data-bf-sticky]');
    var anchor = document.querySelector('[data-bf-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var dismissed = ssGet(STICKY_KEY) === '1';
    var anchorVisible = true;
    var completedHere = false;
    function update() {
      var on = !dismissed && !anchorVisible && (!signedUp() || completedHere);
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    new IntersectionObserver(function (entries) { anchorVisible = entries[0].isIntersecting; update(); }, { threshold: 0 }).observe(anchor);
    var close = bar.querySelector('[data-bf-sticky-close]');
    if (close) close.addEventListener('click', function () { dismissed = true; ssSet(STICKY_KEY, '1'); update(); });
    document.addEventListener('bf:signedup', function (e) {
      if (e.detail && bar.contains(e.detail.form)) completedHere = true; else dismissed = true;
      update();
    });
    document.addEventListener('bf:done', function (e) {
      if (e.detail && bar.contains(e.detail.form)) setTimeout(function () { dismissed = true; update(); }, 3500);
    });
    if (signedUp()) dismissed = true;
    update();
  }

  // Site pop-up: 3 s after landing (or exit intent on desktop), once per session, hidden for 3 days after closing.
  function initPopup() {
    var pop = document.querySelector('[data-bf-popup]');
    if (!pop || signedUp()) return;
    if (CFG.popupEnd && Date.now() > CFG.popupEnd) return;
    document.addEventListener('bf:step', function (e) {
      if (e.detail && pop.contains(e.detail.form)) { var intro = pop.querySelector('[data-bf-pop-intro]'); if (intro) intro.hidden = e.detail.step !== 'phone'; }
    });
    document.addEventListener('bf:done', function (e) {
      if (e.detail && pop.contains(e.detail.form)) { var later = pop.querySelector('.bf-pop__later'); if (later) later.hidden = true; }
    });
    var teaser = document.querySelector('[data-bf-teaser]');
    var closedAt = parseInt(lsGet(CLOSED_KEY) || '0', 10);
    var recentlyClosed = closedAt && (Date.now() - closedAt) < HIDE_DAYS * 864e5;
    var opened = false;
    var lastFocus = null;
    function open() {
      if (signedUp()) return;
      opened = true; ssSet(SESSION_KEY, '1');
      lastFocus = document.activeElement;
      pop.hidden = false; if (teaser) teaser.hidden = true;
      document.documentElement.style.overflow = 'hidden';
      var input = pop.querySelector('[data-step]:not([hidden]) input');
      if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 60);
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'bf26_popup_open' }); } catch (e) {}
    }
    function close() {
      pop.hidden = true;
      document.documentElement.style.overflow = '';
      if (!signedUp()) { lsSet(CLOSED_KEY, String(Date.now())); if (teaser) teaser.hidden = false; }
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }
    var closers = pop.querySelectorAll('[data-bf-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    if (teaser) teaser.addEventListener('click', open);
    document.addEventListener('bf:signedup', function () { if (teaser) teaser.hidden = true; });

    if (recentlyClosed) { if (teaser) teaser.hidden = false; return; }
    if (ssGet(SESSION_KEY) === '1') { if (teaser) teaser.hidden = false; return; }
    setTimeout(function () { if (!opened) open(); }, CFG.popupDelay || 3000);
    if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
      document.addEventListener('mouseout', function (e) { if (!opened && !e.relatedTarget && e.clientY <= 0) open(); });
    }
  }

  function init() {
    var forms = document.querySelectorAll('[data-bf-form]');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
    initSticky();
    initPopup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
